export const WIDGET_TEAM_KPI_TYPE = 'learning-team-kpi';
